import { Space } from 'antd';
import styled from 'styled-components';

const TextUsers = styled.span`
  color: #9ba3b6;
  font-size: 100%;
  & .count {
    margin-right: 3px;
  }
`;

const SpaceText = styled(Space)`
  margin-bottom: 2%;
  margin-left: 2.1%;
`;

const ContentActions = styled.ul``;

const ActionItem = styled.div`
  display: flex;
  gap: 20px;
  justify-content: left;
  :hover {
    /* font-weight: 570; */
    background-color: #e4e7ea;
  }
  .anticon {
    margin-top: 4px;
  }
  .buttonAction {
    display: flex;
    border: none;
    width: 100%;
    background: transparent;
    justify-content: left;
  }
`;

export { TextUsers, SpaceText, ContentActions, ActionItem };
